export var AUTHZ_DATA_RECEIVED = 'authz/dataReceived';

export var receiveGlobalApp = function receiveGlobalApp(app) {
    return {
        type: AUTHZ_DATA_RECEIVED,
        isAdmin: app.role.name === 'Admin'
    };
};

export var receiveMuseumApp = function receiveMuseumApp() {
    return {
        type: AUTHZ_DATA_RECEIVED,
        isAdmin: false
    };
};